// Module
var code = `<div>
  <sub-header header="\$ctrl.formTitle"></sub-header>
  <form name="\$ctrl.form">
      <form-section>
        <table class="table">
          <tbody class="tbody">
          <tr>
            <td></td>
            <td>Grant date:</td>
            <td class="values">
              <date output-format="local-date"
                    min="\$ctrl.minGrantDate"
                    max="\$ctrl.maxGrantDate"
                    ng-required="true"
                    ng-disabled="!\$ctrl.createMode"
                    ng-model="\$ctrl.creditLine.grantDate"
                    ng-change="\$ctrl.setExpirationDate()"></date>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Expiration date:</td>
            <td class="values">
              <date output-format="local-date"
                    ng-required="true"
                    min="\$ctrl.minExpirationDate"
                    ng-model="\$ctrl.creditLine.expirationDate"></date>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Description:</td>
            <td class="values">
              <input
                type="text"
                placeholder="Description"
                ng-required="true"
                ng-model="\$ctrl.creditLine.description"
                ng-maxlength="512"/>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Type:</td>
            <td class="values">
              <select
                required
                ng-model="\$ctrl.creditLine.replenishmentType"
                ng-disabled="!\$ctrl.createMode"
                ng-options="o.value as o.label for o in \$ctrl.replenishmentTypes">
              </select>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Approved credit line:</td>
            <td class="values">
              <cash ng-required="true"
                    ng-model="\$ctrl.creditLine.approvedCreditLine"
                    min="\$ctrl.minCash"
              ></cash>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Loan products</td>
            <td>
              <multiselect
                items="\$ctrl.availableLoanProducts"
                value-property="'id'"
                label-property="'productName'"
                ng-required="true"
                ng-change="\$ctrl.setupLoanTypeNames()"
                ng-model="\$ctrl.creditLine.loanTypeIds"
              >
              </multiselect>
            </td>
          </tr>
          </tbody>
        </table>

      </form-section>
  </form>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/credit-line/common/customer-credit-line-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;